import { useState, useEffect } from 'react'
import { Form, Field } from 'react-final-form'
import { connect } from 'react-redux'
import { toastr } from 'react-redux-toastr'
import { withRouter } from 'react-router-dom'
import { Row, Col, Card, CardBody, CardHeader, FormGroup } from 'reactstrap'
import { fetchAgencies } from '../../actions/agencies'
import brandit_rails from '../../api/brandit_rails'
import { DropdownListNew2, renderInput, ReduxFormSwitch } from '../general/FormInputs'
import SaveButton from '../general/SaveButton'
import SectionWithLabel from '../general/SectionWithLabel'

const fetchAgencyPlans = async () => {
  const response = await brandit_rails.get('/admin/organization/agency_plans')
  return response.data
}

const fetchAdmins = async () => {
  const response = await brandit_rails.get('/admin/organization/account_reps')
  return response.data
}

const fetchAgency = async id => {
  const response = await brandit_rails.get(`/admin/organization/agencies/${id}`)
  return response.data
}

const AgencyCreateEdit = props => {
  const [plans, setPlans] = useState([])
  const [admins, setAdmins] = useState([])
  const [loading, setLoading] = useState(true)
  const [agency, setAgency] = useState({})

  useEffect(() => {
    const fetchData = async () => {
      try {
        const plansData = await fetchAgencyPlans()
        setPlans(plansData)

        const adminsData = await fetchAdmins()
        setAdmins(adminsData)

        if (!props.match.params.id) return

        const agencyData = await fetchAgency(props.match.params.id)
        setAgency(agencyData)
      } catch (error) {
        console.error('Error fetching data:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [props.match.params.id])

  const onSubmit = async (values, shouldNavigate = true) => {
    try {
      // if editing existing agency
      if (props.match.params.id) {
        await brandit_rails
          .put(`/admin/organization/agencies/${props.match.params.id}`, { agency: values })
          .then(response => {
            if (response.status === 200) {
              props.fetchAgencies().then(() => {
                if (!shouldNavigate) return
                props.history.push('/agencies')
              })
            }
          })
        return
      }

      await brandit_rails.post('/admin/organization/agencies', { agency: values }).then(response => {
        if (response.status === 201) {
          props.fetchAgencies().then(() => {
            if (!shouldNavigate) return
            props.history.push('/agencies')
          })
        }
      })
    } catch (error) {
      console.error('Error creating agency:', error)
      if (error.response.status === 422) {
        console.error('Validation errors:', error.response.data)
        toastr.error('Error', error.response.data)
      }
    }
  }

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{
        ...agency,
        account_status: 'active'
      }}
      render={({ handleSubmit, form, submitting, pristine, values }) => {
        return (
          <form onSubmit={handleSubmit}>
            <Card>
              <CardHeader style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div className="mr-2">Create Agency</div>
                <SaveButton onSaveAndClose={handleSubmit} onSaveAndEdit={() => onSubmit(values, false)} />
              </CardHeader>
              <CardBody>
                <SectionWithLabel label="Agency Details">
                  <Row>
                    <Col>
                      <FormGroup>
                        <Field label="* Agency Name" name="name" component={renderInput} placeholder="Agency Name" />
                        <Field
                          label="* MF Account Rep"
                          name="account_rep_admin_id"
                          component={DropdownListNew2}
                          options={admins}
                          placeholder={loading ? 'Loading...' : 'Select Account Rep'}
                          getOptionValue={option => option.admin_id}
                          getOptionLabel={option => option.admin_name}
                          value={values.account_rep_admin_id}
                        />
                      </FormGroup>
                    </Col>
                    <Col>
                      <Field
                        name="hubspot_link"
                        component={renderInput}
                        placeholder="Hubspot Link"
                        label="Hubspot Link"
                      />{' '}
                    </Col>
                  </Row>
                </SectionWithLabel>

                <SectionWithLabel label="Owner Details">
                  <Row>
                    <Col>
                      <Field name="owner_name" component={renderInput} label="* Owner Name" />
                      <Field type="email" name="owner_email" component={renderInput} label="* Owner Email" />
                    </Col>
                  </Row>
                </SectionWithLabel>

                <SectionWithLabel label="Billing & Account Details">
                  <Row>
                    <Col>
                      <Field
                        name="agency_plan_id"
                        label="* Plan"
                        component={DropdownListNew2}
                        options={plans}
                        placeholder={loading ? 'Loading...' : 'Select Plan'}
                        getOptionValue={option => option.id}
                        getOptionLabel={option => option.name}
                        value={values.plan_id}
                      />

                      {/* <SectionWithLabel label="Trial Terms">
                        <Row>
                          <Col>
                            <Field
                              label="Start Date"
                              type="date"
                              name="trial_start_date"
                              component={renderDateRangeBox}
                            />
                          </Col>
                          <Col>
                            <Field name="trial_end_date" type="date" label="End Date" component={renderDateRangeBox} />
                          </Col>
                        </Row>
                      </SectionWithLabel> */}
                    </Col>
                  </Row>
                </SectionWithLabel>

                <SectionWithLabel label="Admin">
                  {/* <Field name="account_status" component={DropdownListNew2} label="Account Status" /> */}
                  <Field name="maintenance_mode" label="Maintenance Mode" component={ReduxFormSwitch} />
                </SectionWithLabel>
              </CardBody>
            </Card>
          </form>
        )
      }}
    />
  )
}
const mapDispatchToProps = {
  fetchAgencies
}
export default withRouter(connect(null, mapDispatchToProps)(AgencyCreateEdit))
